import {h} from 'preact';
import MobileNav from '../../';
import {cxMenu} from '../../styles';
import {appendHashToUrl} from '@util/URLUtils';

const ItemLeaf = ( {sysId, title, url, urlHash, cssClass} ) =>
    <li>
        <a href={appendHashToUrl( url, urlHash )} className={cxMenu.item}>
            {MobileNav.renderIcon( cssClass )}
            <span className={cxMenu.itemLabel}>{title}</span>
        </a>
    </li>;

export default ItemLeaf;